import $ from 'jquery'

/* global filterOptgroupOptions, refreshTomSelect -- exposed by tom-select.js */

// QrCode data_acquisition_type
// ---------------------------------------------------------------------

$(document).on('turbo:load turbo:render', () => {
  const selectDataAcquisitionType = $('#qr_code_data_acquisition_type')
  const selectLocationType = $('#qr_code_location_type')

  // Only proceed if we're on a page with QR code form
  if (!(selectDataAcquisitionType.length > 0 && selectLocationType.length > 0)) return

  const selectSgcSgGroup = $('#select_sgc_sg_group')
  const selectServiceGroup = $('.select_service_group')
  const selectNoticeKindGroup = $('#select_notice_kind_group')
  const selectNoticeKind = $('.select_notice_kind')
  const selectTicketKindGroup = $('#select_ticket_kind_group')
  const selectTicketKind = $('.select_ticket_kind')
  const selectTimeTrackingTypesGroup = $('#select_time_tracking_types_group')
  const selectTimeTrackingTypes = $('.select_time_tracking_types')
  const selectMaintenanceTemplateGroup = $('#select_maintenance_template_group')
  const selectMaintenanceTemplate = $('.select_maintenance_template')

  // Store original location_type options. A Turbo visit runs this handler on
  // turbo:render and again on turbo:load; re-reading the <select> the second
  // time would capture the options the first run already filtered out.
  let locationTypeOptions = selectLocationType.data('source-options-html')
  if (locationTypeOptions == null) {
    locationTypeOptions = selectLocationType.html()
    selectLocationType.data('source-options-html', locationTypeOptions)
  }
  const locationTypeOrder = ['Estate', 'Building', 'Floor', 'Room', 'Vehicle', 'Equipment']
  const locationTypeLabels = {}
  $('<select></select>').html(locationTypeOptions).find('option').each(function() {
    const optionValue = $(this).val()
    if (optionValue === '') return
    locationTypeLabels[optionValue] ||= $(this).text()
  })

  const rebuildLocationTypeOptions = (allowedValues) => {
    const nativeSelect = selectLocationType[0]
    if (nativeSelect == null) return

    nativeSelect.innerHTML = ''

    for (const optionValue of allowedValues) {
      if (locationTypeLabels[optionValue] == null) continue
      nativeSelect.add(new Option(locationTypeLabels[optionValue], optionValue))
    }
  }

  // Only Maintenance can be located at a Room, Vehicle or Equipment
  const allowedLocationTypeValues = () => {
    if (selectDataAcquisitionType.val() === 'Maintenance') return locationTypeOrder
    return ['Estate', 'Building', 'Floor']
  }

  const normalizeLocationTypeOrder = (allowedValues) => {
    const nativeSelect = selectLocationType[0]
    if (nativeSelect == null) return

    // Tom Select reorders selected <option> tags in the backing <select>.
    // Restore a stable domain-specific order for both the native element and dropdown.
    for (const optionValue of allowedValues) {
      const optionEl = nativeSelect.querySelector(`option[value='${optionValue}']`)
      if (optionEl != null) nativeSelect.append(optionEl)
    }

    if (nativeSelect.tomselect != null) {
      allowedValues.forEach((optionValue, idx) => {
        if (nativeSelect.tomselect.options[optionValue] == null) return
        nativeSelect.tomselect.options[optionValue].$order = idx + 1
      })
      nativeSelect.tomselect.lastQuery = null
      nativeSelect.tomselect.refreshOptions(false)
    }
  }

  // Filter location_type options based on data_acquisition_type
  const filterLocationTypeOptions = () => {
    const currentValue = selectLocationType.val()
    if (selectLocationType[0]?.tomselect) selectLocationType[0].tomselect.destroy()
    const allowedValues = allowedLocationTypeValues()

    rebuildLocationTypeOptions(allowedValues)

    // Restore selection if still valid
    if (selectLocationType.find(`option[value='${currentValue}']`).length > 0) {
      selectLocationType.val(currentValue)
    } else {
      selectLocationType.val('')
    }

    refreshTomSelect(selectLocationType)
    normalizeLocationTypeOrder(allowedValues)
  }

  selectLocationType.off('change.qrCodeLocationTypeOrder').on('change.qrCodeLocationTypeOrder', () => {
    normalizeLocationTypeOrder(allowedLocationTypeValues())
  })

  selectDataAcquisitionType.off('change.qrCodeDataAcquisition').on('change.qrCodeDataAcquisition', () => {
    // First disable everything
    selectSgcSgGroup.addClass('d-none')
    selectServiceGroup.attr('name', 'disabled')
    selectNoticeKindGroup.addClass('d-none')
    selectNoticeKind.attr('name', 'disabled')
    selectTicketKindGroup.addClass('d-none')
    selectTicketKind.attr('name', 'disabled')
    selectTimeTrackingTypesGroup.addClass('d-none')
    selectTimeTrackingTypes.attr('name', 'disabled')
    selectMaintenanceTemplateGroup.addClass('d-none')
    selectMaintenanceTemplate.attr('name', 'disabled')
    // … then enable conditionally
    switch (selectDataAcquisitionType.val()) {
      case 'Inspection':
        selectSgcSgGroup.removeClass('d-none')
        selectServiceGroup.attr('name', 'qr_code[service_group_id]')
        break
      case 'Notice':
        selectNoticeKindGroup.removeClass('d-none')
        selectNoticeKind.attr('name', 'qr_code[notice_kind_id]')
        break
      case 'Ticket':
        selectTicketKindGroup.removeClass('d-none')
        selectTicketKind.attr('name', 'qr_code[ticket_kind_id]')
        break
      case 'TimeTracking':
        selectTimeTrackingTypesGroup.removeClass('d-none')
        selectTimeTrackingTypes.attr('name', 'qr_code[time_tracking_type_id]')
        break
      case 'Maintenance':
        // Show maintenance template for all Maintenance types
        selectMaintenanceTemplateGroup.removeClass('d-none')
        selectMaintenanceTemplate.attr('name', 'qr_code[maintenance_template_id]')
        break
    }

    // Filter location type options based on data acquisition type
    filterLocationTypeOptions()
  })

  // IMPORTANT
  // Also trigger everything after page (re)load, e.g. validation fail
  if (selectDataAcquisitionType.length > 0) {
    selectDataAcquisitionType.trigger('change')
  }
})

// QrCode location_id
// ---------------------------------------------------------------------

$(document).on('turbo:load turbo:render', () => {
  const selectEstate = $('.select_location_estate')
  const selectBuilding = $('.select_location_building')
  const selectFloor = $('.select_location_floor')

  // Only proceed if we're on a page with QR code form
  if (!($('#qr_code_form').length > 0 && selectEstate.length > 0)) return
  if (selectEstate.first().closest('[data-cascade]').length > 0) return

  // Destroy Tom Select on cascading selects so we can capture the raw server-rendered
  // <option>/<optgroup> HTML. refreshTomSelect() will re-init them after each cascade.
  for (const el of [selectBuilding, selectFloor]) {
    if (el[0]?.tomselect) el[0].tomselect.destroy()
  }

  const buildings = selectBuilding.html()
  const floors = selectFloor.html()

  const emptyOption = "<option value='' selected='selected'></option>"

  // Disable secondary/tertiary selects of cascades
  if (selectEstate.val() === '') selectBuilding.prop('disabled', true)
  if (selectBuilding.val() === '') selectFloor.prop('disabled', true)

  // Populate buildings
  const selectedBuilding = selectBuilding.find('option:selected').val()
  selectEstate.off('change.qrCodeLocationCascade').on('change.qrCodeLocationCascade', () => {
    const selectedEstate = selectEstate.val()
    const selectedEstateLabel = selectEstate.find('option:selected').text()
    const options = filterOptgroupOptions(buildings, selectedEstate, selectedEstateLabel, selectEstate[0]?.selectedIndex)
    const numberOfBuildings = options ? (options.match(/value/g) || []).length : 0
    if (options) {
      selectBuilding.prop('disabled', false)
      selectBuilding.html(options)
      // If nothing is selected yet, add empty option, so User has to select right value first, but only when more than one Building is selectable
      if (!(selectedBuilding > 0 || numberOfBuildings === 1)) {
        selectBuilding.prepend(emptyOption)
      }
      if (selectBuilding.val() === '') selectFloor.prop('disabled', true)
    } else {
      selectBuilding.empty()
    }
    refreshTomSelect(selectBuilding)
    populateSelectFloors()
  })

  // Populate floors
  selectBuilding.off('change.qrCodeLocationCascade').on('change.qrCodeLocationCascade', () => {
    if (selectBuilding.val() !== '') selectFloor.prop('disabled', false)
    populateSelectFloors()
  })

  const populateSelectFloors = () => {
    const building = selectBuilding.val()
    const buildingLabel = selectBuilding.find('option:selected').text()
    const options = filterOptgroupOptions(floors, building, buildingLabel, selectBuilding[0]?.selectedIndex)
    const floor = selectFloor.find('option:selected').val()
    const numberOfFloors = options ? (options.match(/value/g) || []).length : 0
    if (options) {
      selectFloor.prop('disabled', false)
      selectFloor.html(options)
      // If nothing is selected yet, add empty option, so User has to select right value first, but only when more than one Floor is selectable
      if (!(floor > 0 || numberOfFloors === 1 || selectFloor.find('option:first-child').val() !== '')) {
        selectFloor.prepend(emptyOption)
      }
    } else {
      selectFloor.empty()
    }
    refreshTomSelect(selectFloor)
  }

  // IMPORTANT
  // Also trigger everything after page (re)load, e.g. validation fail
  selectEstate.trigger('change')
})

// QrCode ServiceGroup
// ---------------------------------------------------------------------

$(document).on('turbo:load turbo:render', () => {
  const selectServiceGroupCategory = $('.select_service_group_category')
  const selectServiceGroup = $('.select_service_group')

  if (selectServiceGroup[0]?.tomselect) selectServiceGroup[0].tomselect.destroy()
  let serviceGroups = selectServiceGroup.data('source-options-html')
  if (serviceGroups == null) {
    serviceGroups = selectServiceGroup.html()
    selectServiceGroup.data('source-options-html', serviceGroups)
  }

  const emptyOption = "<option value='' selected='selected'></option>"

  if (selectServiceGroup.val() === '') selectServiceGroup.prop('disabled', true)

  // Populate service groups
  const selectedServiceGroup = selectServiceGroup.find('option:selected').val()
  selectServiceGroupCategory.off('change.qrCodeServiceGroup').on('change.qrCodeServiceGroup', () => {
    const selectedServiceGroupCategory = selectServiceGroupCategory.val()
    const selectedServiceGroupCategoryLabel = selectServiceGroupCategory.find('option:selected').text()
    const options = filterOptgroupOptions(serviceGroups, selectedServiceGroupCategory, selectedServiceGroupCategoryLabel, selectServiceGroupCategory[0]?.selectedIndex)
    const numberOfServiceGroups = options ? (options.match(/value/g) || []).length : 0
    if (options) {
      selectServiceGroup.prop('disabled', false)
      selectServiceGroup.html(options)
      // If nothing is selected yet, add empty option, so User has to select right value first, but only when more than one ServiceGroup is selectable
      if (!(selectedServiceGroup > 0 || numberOfServiceGroups === 1)) {
        selectServiceGroup.prepend(emptyOption)
      }
      if (selectServiceGroupCategory.val() === '') selectServiceGroup.prop('disabled', true)
    } else {
      selectServiceGroup.empty()
    }
    refreshTomSelect(selectServiceGroup)
  })

  // IMPORTANT
  // Also trigger everything after page (re)load, e.g. validation fail
  selectServiceGroupCategory.trigger('change')
})
